/**
 * パスを正規化する。
 *
 * 受け取ったパスを、スラッシュ区切りの表現に正規化します。
 * Windowsのボリュームラベルが付いている場合は削除します。
 * URIスキーム(http, https, ftp など) で始まる場合、2つのスラッシュで始まる場合(`//www.example.com/abc/` など)、これを残して正規化します。
 *
 *  - 例： `\a\b\c.html` → `/a/b/c.html` バックスラッシュはスラッシュに置き換えられます。
 *  - 例： `/a/b////c.html` → `/a/b/c.html` 余計なスラッシュはまとめられます。
 *  - 例： `C:\a\b\c.html` → `/a/b/c.html` ボリュームラベルは削除されます。
 *  - 例： `http://a/b/c.html` → `http://a/b/c.html` URIスキームは残されます。
 *  - 例： `//a/b/c.html` → `//a/b/c.html` ドメイン名は残されます。
 *
 * @param string $path 正規化するパス
 * @return string 正規化されたパス
 */
module.exports = function($path){
    $path = this.trim($path);
    // $path = $this->convert_encoding( $path );//文字コードを揃える
    $path = $path.replace( /\/|\\/g, '/' );//バックスラッシュをスラッシュに置き換える。
    $path = $path.replace( /^[A-Za-z]\:\//g, '/' );//Windowsのボリュームラベルを削除
    var $prefix = '';
    if( $path.match( /^((?:[a-zA-Z0-9]+\:)?\/)(\/[\s\S]*)$/, $path ) ){
        $prefix = RegExp.$1;
        $path = RegExp.$2;
    }
    $path = $path.replace( /\/+/g, '/' );//重複するスラッシュを1つにまとめる
    return $prefix+$path;
}
